import { createEntityAdapter } from '@reduxjs/toolkit';
import { ResultResponsePrivate } from '@tests/types';

export const resultsAdapter = createEntityAdapter<ResultResponsePrivate<string>>();
